"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const spanishTranslation = {
    removeGiftCardText: 'Eliminar tarjeta de regalo',
    editSectionButton: 'Sección de Edición',
};
exports.default = spanishTranslation;
